module.exports = __webpack_public_path__ + "img/image2.45d3a12b.png";